module.exports = __webpack_public_path__ + "static/icon__collaboration--multicolor-9ed15c62b0950e8ea00cff2f6113e001.png";